export default "__VITE_ASSET__15f450e6__"